var modules_2529eb59 = {"layout":"_12sp54u","containerBgColor-primary":"_17fzd4x","containerBgColor-secondary":"_d2nv7v","appBanner":"_97wvim","storesBanner":"_14msm6j","contactsBanner":"_1aihpka"};
import "../../../assets/9H6-089S.css";

export { modules_2529eb59 as default };
//# sourceMappingURL=Footer.module.less.js.map
